import CardMembershipIcon from "@mui/icons-material/CardMembership";
import EditNotificationsIcon from "@mui/icons-material/EditNotifications";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import ListItemIcon from "@mui/material/ListItemIcon";
import LogoutIcon from "@mui/icons-material/Logout";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PersonIcon from "@mui/icons-material/Person";

type UserProfileMenuViewProps = {
  open: boolean;
  onClose: () => void;
  onProfileClick: () => void;
  onSubscriptionClick: () => void;
  onNotificationSettingsClick: () => void;
  onRhythmClick: () => void;
  onLogout: () => void;
  anchorEl: null | HTMLElement;
};

const UserProfileMenuView: React.FC<UserProfileMenuViewProps> = ({
  open,
  onClose,
  onProfileClick,
  onSubscriptionClick,
  onNotificationSettingsClick,
  onRhythmClick,
  onLogout,
  anchorEl,
}) => {
  return (
    <Menu
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
    >
      <MenuItem onClick={onProfileClick}>
        <ListItemIcon>
          <PersonIcon fontSize="small" />
        </ListItemIcon>
        Profile
      </MenuItem>
      <MenuItem onClick={onSubscriptionClick}>
        <ListItemIcon>
          <CardMembershipIcon fontSize="small" />
        </ListItemIcon>
        Subscription
      </MenuItem>
      <MenuItem onClick={onNotificationSettingsClick}>
        <ListItemIcon>
          <EditNotificationsIcon fontSize="small" />
        </ListItemIcon>
        Notification Settings
      </MenuItem>
      <MenuItem onClick={onRhythmClick}>
        <ListItemIcon>
          <EventRepeatIcon fontSize="small" />
        </ListItemIcon>
        Your rhythm
      </MenuItem>
      <MenuItem onClick={onLogout}>
        <ListItemIcon>
          <LogoutIcon fontSize="small" />
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
  );
};

export default UserProfileMenuView;
